import React, { useState } from 'react';

import { Box } from '@mui/material';
import { useConfirmation } from 'components/Confirmation';
import DeleteButton from 'components/DeleteButton';
import MediaTypography from 'components/MediaTypography';
import DownloadButton from 'modules/Report/components/DownloadButon';
import EditButton from 'modules/Report/components/EditButton';
import ReportUploadFileModal from 'modules/Report/components/Modal';
import ReportInfoBlockItemStatus from 'modules/Report/components/Status';

import {
	type DownloadListItemProps,
	type FullListItemProps,
	type InfoListItemProps,
} from '@common/modules/Report/types';

import StyledInfoBlockListItemWrap from './styled';

export type ListItemProps = InfoListItemProps | DownloadListItemProps | FullListItemProps;

function ReportInfoBlockListItem({ ...props }: ListItemProps) {
	const [isModalOpen, setIsModalOpen] = useState(false);

	const handleModalOpen = (value: boolean) => () => {
		setIsModalOpen(value);
	};

	const confirm = useConfirmation();

	switch (props.type) {
		case 'info':
			return (
				<StyledInfoBlockListItemWrap sx={{ padding: '16px' }}>
					<MediaTypography variant="body1" lineClamp={{ default: 1 }}>
						{props.title}
					</MediaTypography>
					<MediaTypography
						variant="caption1"
						lineClamp={{ default: 1 }}
						textColor="helper"
						component="p"
					>
						{props.subTitle}
					</MediaTypography>
				</StyledInfoBlockListItemWrap>
			);
		case 'download':
			return (
				<StyledInfoBlockListItemWrap>
					<Box sx={{ minWidth: 0 }}>
						<MediaTypography variant="body1" lineClamp={{ default: 1 }}>
							{props.title}
						</MediaTypography>
						<MediaTypography
							variant="caption1"
							lineClamp={{ default: 1 }}
							textColor="helper"
							component="p"
						>
							{props.subTitle}
						</MediaTypography>
					</Box>
					<DownloadButton href={props.href} download={props.download} />
				</StyledInfoBlockListItemWrap>
			);
		case 'full':
			return (
				<>
					<StyledInfoBlockListItemWrap>
						<Box sx={{ minWidth: 0 }}>
							<Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
								<MediaTypography variant="body1" lineClamp={{ default: 1 }}>
									{props.title}
								</MediaTypography>
								<ReportInfoBlockItemStatus status={props.status} />
							</Box>
							<MediaTypography
								variant="caption1"
								lineClamp={{ default: 1 }}
								textColor="helper"
								component="p"
							>
								{props.subTitle}
							</MediaTypography>
						</Box>
						{props.status === 'Completed' ? (
							<DownloadButton href={props.href} download={props.download} />
						) : (
							<Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
								<EditButton handleClick={handleModalOpen(true)} />
								<DeleteButton
									onClick={() =>
										confirm({
											text: `You want to delete this file "${props.title}"`,
										})
											.then(() => props.onDelete())
											.catch(() => {})}
									size="small"
								/>
							</Box>
						)}
					</StyledInfoBlockListItemWrap>
					<ReportUploadFileModal
						open={isModalOpen}
						onClose={handleModalOpen(false)}
						handleSubmit={(data) => {
							props.onEdit(data);
							handleModalOpen(false);
						}}
						initialValues={props.initialValues}
					/>
				</>
			);
		default:
			return null;
	}
}

export default ReportInfoBlockListItem;
